import Vue from "vue";
import QuestionFile from "components/AliyunOSS/QuestionFile.vue";
export default Vue.extend({
  name: "EnclosureQuestion",
  components: {
    QuestionFile: QuestionFile
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    paperId: {
      type: String,
      default: ""
    },

    /* --------------------------跳转页面参数----------------------------- */
    paperType: {
      type: String,
      default: "Paper"
    },
    faceId: {
      type: String,
      default: ""
    },
    classId: {
      type: String,
      default: ""
    } // faceTeachState: {
    //   type: String,
    //   default: ""
    // },

    /* ------------------------------------------------------------------- */

  },
  data: function data() {
    return {
      content: {},
      fileList: [],
      title: "",
      desceiption: "",
      urlAliyunOSS: '/api/XOrg/AssociationIndex/getSign',
      fileIds: [],
      filesList: [],
      IsShowFile: true,
      // 是否展示富文本框
      isShowEditor: true,
      isShowInput: false,
      // 总分
      totalScore: 0,
      Score: 0,
      isTotalScore: false
    };
  },
  watch: {},
  created: function created() {
    this.getEnclosureQuestion();
  },
  methods: {
    // 返回上级
    goback: function goback() {
      this.$router.go(-1);
    },
    handleRemove: function handleRemove(file, fileList) {},
    handlePreview: function handlePreview(file) {},
    getEnclosureQuestion: function getEnclosureQuestion() {
      var _this = this;

      this.$http.post('/api/XOrg/BookMaterial/geEnclosureInfoById', {
        paperId: this.paperId
      }).then(function (rst) {
        _this.title = rst.info.Title;
        _this.desceiption = rst.info.Descriptioin;
        _this.filesList = rst.info.FileList;
        _this.totalScore = rst.info.TotalScore;
        _this.Score = rst.info.TotalScore;
      });
    },
    addEnclosureQuestion: function addEnclosureQuestion() {
      var _this2 = this;

      this.$http.post('/api/XOrg/BookMaterial/editEnclosurePaperById', {
        paperId: this.paperId,
        title: this.title,
        desceiption: this.desceiption,
        fileIds: this.fileIds
      }).then(function (rst) {
        if (rst.code > 0) {
          _this2.$message.success(rst.msg); // this.$router.push({
          //   name: "Paper",
          //   params: {
          //     courseId: this.courseId
          //   }
          // });


          _this2.$router.go(-1);
        } else {
          _this2.$message.warning(rst.msg);
        }
      });
    },
    goto: function goto(name, params) {
      if (this.paperType === "lectures") {
        this.$router.push({
          name: this.paperType,
          params: {
            courseId: this.courseId,
            classId: this.classId,
            faceId: this.faceId // faceTeachState:this.faceTeachState

          }
        });
      } else {
        this.$router.push({
          name: this.paperType,
          params: params
        });
      }
    },
    Preview: function Preview(data) {
      this.isShowEditor = !data;
    },
    shuxin: function shuxin(data) {
      //
      this.IsShowFile = false;
      this.IsShowFile = true;
    },
    showTitleInput: function showTitleInput() {
      this.isShowInput = true;
    },
    hideTitleInput: function hideTitleInput() {
      this.isShowInput = false;
      this.updatePaperName();
    },
    updatePaperName: function updatePaperName() {
      var _this3 = this;

      this.$http.post('/api/XOrg/BookMaterial/updatePaperName', {
        paperId: this.paperId,
        paperName: this.title
      }).then(function (rst) {
        if (rst.code > 0) {
          _this3.$message.success(rst.msg);
        } else {
          _this3.$message.warning(rst.msg);
        }
      });
    },
    updatePaperScore: function updatePaperScore() {
      var _this4 = this;

      this.$http.post('/api/XOrg/BookMaterial/updatePaperScore', {
        paperId: this.paperId,
        totalScore: this.totalScore
      }).then(function (rst) {
        if (rst.code > 0) {
          _this4.$message.success(rst.msg);
        } else {
          _this4.$message.warning(rst.msg);
        }
      });
    },
    showTotalScore: function showTotalScore() {
      this.isTotalScore = true;
    },
    hideScoreInput: function hideScoreInput() {
      this.isTotalScore = false;

      if (this.totalScore < 0 || this.totalScore > 1000) {
        this.totalScore = this.Score;
        this.$message.warning("总分必须在0~1000之间");
      } else {
        this.updatePaperScore();
      }
    }
  }
});